import { FC } from 'react';
import { Box } from '@material-ui/core';
import { LaunchTestButton } from './LaunchTestButton';

export const TestCardActions: FC = () => {
  return (
    <Box display="flex" alignItems="center">
      <LaunchTestButton />
    </Box>
  );
};
